module.exports = __webpack_public_path__ + "img/wrapbg6.a2a87ac4.png";